<div class="flex flex-col">
  <!-- Edition groups by year -->
  @for (group of groupedEditions(); track group.year) {
    <!-- Year heading -->
    <h2 class="py-4 text-3xl lg:py-6 lg:text-6xl">
      {{ group.year }}
    </h2>
    <!-- Mobile View -->
    <div class="block w-full md:hidden">
      @for (edition of group.editions; track edition.id) {
        <div
          class="flex cursor-pointer items-center justify-between border-b py-2 transition-all duration-300"
          [routerLink]="[
            '/magazines/detail',
            magazine()?.id,
            magazine()?.slug,
            'edition',
            edition.id,
          ]"
        >
          <span class="text-lg font-medium">
            {{
              'components.journalItem.editionVersion'
                | translate: { edition: edition.edition_version }
            }}
          </span>
          <img
            class="h-3 w-3 transition-all duration-300"
            src="assets/icons/diagonal_arrow_icon.svg"
            alt="Arrow Icon"
          />
        </div>
      }
    </div>
    <!-- Desktop View -->
    <div class="hidden flex-col md:flex">
      @for (edition of group.editions; track edition.id) {
        <div
          class="grid grid-cols-2 border-b border-black/20 py-8 last:border-b-0"
        >
          <!-- Image Column -->
          <div class="w-1/2 max-w-sm min-w-80">
            <a
              [routerLink]="[
                '/magazines/detail',
                magazine()?.id,
                magazine()?.slug,
                'edition',
                edition.id,
              ]"
            >
              <img
                class="object-contain"
                [src]="
                  magazine()?.media?.cover?.url ??
                  '/assets/images/image-placeholder.png'
                "
                [alt]="
                  'components.magazineEditionOverview.coverImage' | translate
                "
              />
            </a>
          </div>
          <!-- Content Column -->
          <div class="inline-flex flex-col items-start justify-start">
            <!-- Title Section -->
            <div class="flex flex-col gap-1">
              <a
                [routerLink]="[
                  '/magazines/detail',
                  magazine()?.id,
                  magazine()?.slug,
                  'edition',
                  edition.id,
                ]"
              >
                <h2
                  class="text-4xl leading-tight font-medium text-primary-text"
                >
                  {{ magazine()?.title }} -
                  <span class="text-nowrap">
                    {{
                      'components.journalItem.editionVersion'
                        | translate: { edition: edition.edition_version }
                    }}
                  </span>
                </h2>
              </a>
              <p class="text-lg text-secondary-text">
                {{
                  'components.journalItem.inThisEditionOfMagazine'
                    | translate: { magazine: magazine()?.title }
                }}
              </p>
            </div>
            <!-- Articles List -->
            <div class="flex w-full flex-col divide-y divide-black/20 py-6">
              <!-- Loading state -->
              @if (loading()) {
                <div class="py-4 text-center text-gray-500">
                  <div class="flex items-center justify-center">
                    <div
                      class="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-orange-500"
                    ></div>
                    <span class="ml-2">{{
                      'components.header.loading' | translate
                    }}</span>
                  </div>
                </div>
              }
              <!-- Error state -->
              @if (error(); as errorMessage) {
                <div class="py-4 text-center text-red-500">
                  {{ errorMessage }}
                </div>
              }
              <!-- No articles state -->
              @if (
                !loading() &&
                !error() &&
                getArticlesForEdition(edition.id).length === 0
              ) {
                <div class="py-4 text-center text-gray-500">
                  {{ 'components.journalItem.noArticlesAvailable' | translate }}
                </div>
              }
              @if (
                !loading() && !error() && getArticlesForEdition(edition.id);
                as editionArticles
              ) {
                <dhp-article-list
                  [articles]="editionArticles | slice: 0 : 6"
                  [embedContext]="'magazineEditionOverview'"
                />
              }
            </div>
            <!-- View Edition Button -->
            <div class="flex items-center gap-4">
              <button
                class="group flex items-center gap-2 transition-all duration-300"
                [routerLink]="[
                  '/magazines/detail',
                  magazine()?.id,
                  magazine()?.slug,
                  'edition',
                  edition.id,
                ]"
              >
                <span
                  class="text-base font-medium text-orange-500 group-hover:text-orange-400"
                >
                  {{ 'components.journalItem.moreInThisEdition' | translate }}
                </span>
                <svg
                  class="transition-all duration-300 group-hover:translate-x-2"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 18L18 6M18 6H10M18 6V14"
                    stroke="#FF572D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
